import { useRef, useEffect } from 'react';

const createWait = (delay) => {
  let cancel = null;
  let timeout = null;

  const wait = () =>
    new Promise((resolve) => {
      stop();
      cancel = () => resolve(false);
      timeout = setTimeout(() => {
        cancel = null;
        timeout = null;
        resolve(true);
      }, delay * 1000);
    });

  const stop = () => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    if (cancel !== null) {
      cancel();
      cancel = null;
    }
  };

  return [wait, stop];
};

// delay is read only on first render; changes after mount are ignored.
// The wait promise resolves true when the delay elapses and false when
// stopped, releasing any chained continuations either way.
const useWait = (delay) => {
  const ref = useRef(null);
  if (ref.current === null) {
    ref.current = createWait(delay);
  }

  const [, stop] = ref.current;
  useEffect(() => stop, []);

  return ref.current;
};

export default useWait;
